import { TextVariant } from './types';

export const USED_TICKET_MODAL_CONSTANTS: Record<string, TextVariant> = {
  contentText: {
    common: (
      <>
        패스워드가 확인되었습니다.
        <br /> 참가자의 참가권을 사용할까요?
      </>
    ),
  },
  cancelBtn: { common: '취소' },
  confirmBtn: { common: '사용하기' },
};
